export default {
    getHeaderFieldsEprofileVercsoport: state => state.headerFieldsEprofileVercsoport,
    getFormActionsEprofileVercsoport: state => state.formActionsEprofileVercsoport,
    getActionsEprofileVercsoport: state => state.actionsEprofileVercsoport,
    getRowActionsEprofileVercsoport: state => state.rowActionsEprofileVercsoport,
    getSearchFields: state => state.searchFields,
    isFormOpenEprofileVercsoport: state => state.formIsOpen,
    isGridOpenEprofileVercsoport: state => state.gridIsOpen
}
